import axios from "axios";

export default class BaseClient {
  constructor(baseURL) {
    this.baseURL = baseURL;
    this.token = localStorage.getItem("token");

    this.client = axios.create({
      baseURL: this.baseURL,
    });

    this.client.interceptors.response.use(
      (res) => res.data,
      (error) => Promise.reject(error)
    );
    this.client.interceptors.request.use(this.validateToken);
  }

  isExpired() { // metodo privado
    const tokenExpirationDate = localStorage.getItem("exp");
    if (tokenExpirationDate !== null) {
      const date = new Date(tokenExpirationDate);
      return new Date() > date;
    }
    return true;
  }

  validateToken = async (config) => { // metodo privado
    if (this.isExpired() || !this.token) {
      // Realizar acciones en caso de token expirado o no disponible
      // Por ejemplo, logout();
      return config;
    } else {
      config.headers.Authorization = `Bearer ${this.token}`;
      return config;
    }
  };

  get(path, params) { // metodo publico
    return this.client.get(path, { params });
  }

  post(path, body) { // metodo publico
    return this.client.post(path, body);
  }

  put(path, body) { // metodo publico
    return this.client.put(path, body);
  }

  delete(path) { // metodo publico
    return this.client.delete(path);
  }
}
